<template>
  <div class="common-page order-management">
    <div class="top-box">
      <div class="search-form-box">
        <el-row :gutter="30">
          <el-form inline>
            <el-col :span="5">
              <el-form-item label="对账单号:" prop="reconciliationNo">
                <el-input clearable placeholder="请输入" v-model="searchForm.reconciliationNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="代理商:" prop="agentCompanyId">
                <el-select
                  style="width: 100%"
                  v-model="searchForm.agentCompanyId"
                  clearable
                  placeholder="请选择">
                  <el-option
                    v-for="item in agentData"
                    :key="item.companyId"
                    :label="item.companyName"
                    :value="item.companyId"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="出账状态:" prop="reconciliationStatus">
                <el-select
                  style="width: 100%"
                  v-model="searchForm.reconciliationStatus"
                  clearable
                  placeholder="请选择">
                  <el-option
                    v-for="item in reconciliationStatusData"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="">
                <el-button type="primary" round icon="el-icon-search" @click="handleCheck()"></el-button>
                <el-button type="default" round icon="el-icon-refresh" @click="handleReset()"></el-button>
              </el-form-item>
            </el-col>
          </el-form>
        </el-row>
      </div>
    </div>

    <div class="custom-table-box">
      <custom-table
        :data="tableData"
        :column="tableColumn"
        :total="tableOptions.total"
        :loading="tableOptions.loading"
        :page="tableOptions.pageNumber"
        :size="tableOptions.pageSize"
        :selection="false"
        @pagination="handleSizeChange">
        <template v-slot:sourceType="{ row }">
          <span v-if="row.sourceType === 1">平台对账</span>
          <span v-if="row.sourceType === 2">第三方对账</span>
        </template>
        <template v-slot:billId="{ row }">
          <span v-if="row.sourceType === 1">手动对账</span>
          <span v-if="row.sourceType === 2">{{row.startTime}} - {{row.endTime}}</span>
        </template>
        <template v-slot:reconciliationStatus="{ row }">
          <el-tag type="danger" v-if="row.reconciliationStatus === 0">未出账</el-tag>
          <el-tag type="primary" v-if="row.reconciliationStatus === 1">已出账</el-tag>
        </template>
        <template v-slot:operation="{ row }">
          <span class="operate-btn" @click="handleDetail(row)">详情</span>
          <span class="operate-btn" @click="handleChu(row)" v-if="row.reconciliationStatus === 0">出账</span>
          <span class="operate-btn" @click="handleDownload(row)">导出</span>
        </template>
      </custom-table>
    </div>
    <detail ref="detail"></detail>
  </div>
</template>

<script>
import OperateBox from "@/components/OperateBox.vue";
import CustomTable from "@/components/CustomTable.vue";
import CustomDateRange from "@/components/CustomDateRange.vue";
import tableMixin from "@/mixin/tableMixin";
import CustomTabBox from "@/components/customComponents/CustomTabBox.vue";
import {numberToThousand} from "@/utils/tool"
import { getPage, reconcile } from "./api";
import { getSelectAgent } from "@/views/SystemManagement/AgentManagement/api";
import Detail from "./detail.vue";
export default {
  name: "ShipperManagement",
  mixins: [tableMixin],
  components: {
    Detail,
    CustomTabBox,
    OperateBox,
    CustomTable,
    CustomDateRange,
  },
  data() {
    return {
      getTableMethod: getPage,
      searchForm: {
        "agentCompanyId": "",
        "reconciliationNo": "",
        "reconciliationStatus": ""
      },
      isImmediatelyGetData: true,
      tableColumn: [
        {
          label: "对账单号",
          prop: "reconciliationNo",
          align: "left",
          show: true,
        },
        {
          label: "代理商",
          prop: "agentCompanyName",
          align: "left",
          show: true,
        },
        {
          label: "对账来源",
          prop: "sourceType",
          align: "left",
          scopeStatus: true,
          show: true,
        },
        {
          label: "对账周期",
          prop: "billId",
          align: "left",
          scopeStatus: true,
          show: true,
        },
        {
          label: "对账人",
          prop: "creator",
          align: "left",
          show: true,
        },
        {
          label: "账单运费",
          prop: "fee",
          align: "left",
          show: true,
        },
        {
          label: "代收金额",
          prop: "agencyFee",
          align: "left",
          show: true,
        },
        {
          label: "平台利润",
          prop: "profit",
          align: "left",
          show: true,
        },
        {
          label: "状态",
          prop: "reconciliationStatus",
          align: "left",
          scopeStatus: true,
          show: true,
        },
        {
          label: "操作",
          prop: "operation",
          fixed: "right",
          width: "240px",
          scopeStatus: true,
          show: true,
        },
      ],
      agentData: [],
      reconciliationStatusData: [
        {
          label: '未出账',
          value: 1,
        },
        {
          label: '已出账',
          value: 0,
        }
      ]
    };
  },
  created() {
    this.getAgentData()
  },
  mounted() {
  },
  methods: {
    numberToThousand,
    getAgentData() {
      getSelectAgent({
        keyword: ''
      }).then(response => {
        if (response.code === 200) {
          this.agentData = response.data
        }
      })
    },
    handleDownload() {
      this.$message.warning("功能等超超")
    },
    handleChu(row) {
      this.$confirm(`确定出账？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      }).then(() => {
        reconcile({
          billId: row.billId,
        }).then((res) => {
          if (res.code === 200) {
            this.getTableData();
          }
        });
      });
    },
    handleChangeTab(val) {
      this.searchForm.companyName = ""
      this.searchForm.rechargeMethod = ""
      this.searchForm.walletStatus = ""
      this.tableOptions.pageNumber = 1;
      this.getTableData();
    },
    handleDetail(row) {
      this.$refs.detail.init(row);
    },
  },
};
</script>
<style lang="scss" scoped>
.order-management {
  .top-box {
    .tab-box {
      padding: 0.2rem 0 0 0.2rem;
    }
  }

  .search-table-box {
    display: flex;
    margin: 0.16rem -0.1rem 0;

    .list-box {
      width: 33.33%;
      height: 0.9rem;
      border-radius: 0.08rem;
      background-color: #ffffff;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin: 0 0.1rem;

      .list-box-num {
        font-size: 0.24rem;
        color: #000000;
        padding-bottom: 0.1rem;
        font-weight: bold;
      }

      .list-box-label {
        font-size: 0.14rem;
        color: #434343;
      }
    }
  }

  .search-form-title {
    font-weight: 400;
    font-size: 0.16rem;
    color: #111827;
    line-height: 0.24rem;
    padding-bottom: 0.08rem;
  }

  .custom-table-box {
    padding-top: 0;
  }

  .drop-image {
    width: 0.24rem;
    height: 0.24rem;
  }

  .owner-requirement {
    background-color: rgba(217, 236, 255, 0.5);
    color: #1269ff;
    padding: 0.05rem;
    border-radius: 0.06rem;
  }

  .mileage {
    position: relative;
    padding: 0 0.05rem 0.06rem;
  }

  .mileage::after {
    content: "→";
    position: absolute;
    left: 0;
    bottom: -0.06rem;
    text-align: center;
    width: 100%;
  }
}
</style>
